import { useQuery } from "@tanstack/react-query";
import filterServices from "../services/filterServices";


export const useFetchInfluencers = (filters, sorting, page, isContacts) => {
  return useQuery({
    queryKey: ["fetchInfluencer", filters, sorting, page, isContacts],
    queryFn: () => filterServices.FetchInfluencers(filters, sorting, page, isContacts),
    staleTime: 1 * 60 * 1000,
    refetchOnWindowFocus: false
  });
};

export const useFetchInfluencersCount = (filters, isContacts, engagedCreators) => {
  return useQuery({
    queryKey: ["fetchInfluencerCount", filters, isContacts, engagedCreators],
    queryFn: () => filterServices.FetchInfluencersCount(filters, isContacts, engagedCreators),
    staleTime: 1 * 60 * 1000,
    refetchOnWindowFocus: false
  });
};

export const useFilteredInfluencers = (filters, sorting, page, isContacts, nextCursor, engagedCreators, engagedSort = 'followers') => {
  return useQuery({
    queryKey: ['filteredInfluencers', filters, sorting, page, isContacts, engagedCreators, engagedSort, nextCursor],
    queryFn: () => filterServices.FilteredInfluencers(filters, sorting, page, isContacts, nextCursor, engagedCreators, engagedSort),
    staleTime: 1 * 60 * 1000,
    refetchOnWindowFocus: false
  });
}

export default { useFetchInfluencers, useFetchInfluencersCount, useFilteredInfluencers };
